import loadable from '@/utils/loadable';

export const LoginPage = loadable(() => import('@/pages/auth/LoginPage'));
export const RegisterPage = loadable(() => import('@/pages/auth/RegisterPage'));
export const HomePage = loadable(() => import('@/pages/Home'));
export const SportsPage = loadable(() => import('@/pages/Sports'));
export const MarketsPage = loadable(() => import('@/pages/Markets'));
export const CasinoPage = loadable(() => import('@/pages/Casino'));
export const CasinoPlaygroundPage = loadable(() => import('@/pages/CasinoPlayground'));
export const GoalGamePage = loadable(() => import('@/pages/GoalGame'));
export const QTECHLobbyPage = loadable(() => import('@/pages/QTECHLobby'));
export const QTECHCasinoPage = loadable(() => import('@/pages/QTECHCasino'));
export const FantasyListPage = loadable(() => import('@/pages/FantasyList'));
export const LiveCasinoPage = loadable(() => import('@/pages/LiveCasino'));
export const SlotsPage = loadable(() => import('@/pages/Slots'));
// Aggregator-backed casino lobby — mounted on /casino/* for brands that use it.
export const NexxCasinoPage = loadable(() => import('@/pages/Casino/NexxCasino'));
export const BlankPage = loadable(() => import('@/pages/BlankPage'));
export const AccountStatementPage = loadable(() => import('@/pages/AccountStatment'));
export const BetHistoryPage = loadable(() => import('@/pages/BetHistory'));
export const AffiliatePage = loadable(() => import('@/pages/Affiliate'));
export const ActivityLogsPage = loadable(() => import('@/pages/ActivityLog'));
export const CasinoResultsPage = loadable(() => import('@/pages/CasinoResults'));
export const AuthVerificationPage = loadable(() => import('@/pages/AuthVerification'));
export const ChangePasswordPage = loadable(() => import('@/pages/ChangePassword'));
export const TermsConditionsPage = loadable(() => import('@/pages/TermsAndConditions'));
export const CasinoBetHistory = loadable(() => import('@/pages/CasinoBetHistory'));
export const DepositWithdrawPage = loadable(() => import('@/pages/DepositWithdraw'));
export const DepositPage = loadable(() => import('@/pages/DepositWithdraw/DepositPage'));
export const FixedDepositPage = loadable(() => import('@/pages/FixedDeposit'));
export const ContactPage = loadable(() => import('@/pages/ContactPage'));
export const WalletHistoryPage = loadable(() => import('@/pages/WalletHistory'));
